import {svgIconWrapper} from '../svg-icon-wrapper';

import ZendeskRegular from './zendesk-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ZendeskRegular {...props} />;
}

SvgComponent.iconName = 'zendeskRegular';

export const ZendeskRegularIcon = svgIconWrapper(SvgComponent);
